import {
  buildCellLookupTable,
  columnToNumber,
  numberToColumn,
  parseCellAddress,
} from "@/jspreadsheet/utils";
export const getCellsFromRange = (range: string): string[] => {
  if (range.includes(":")) {
    const [start, end] = range.split(":");
    const { column: startCol, row: startRow } = parseCellAddress(start);
    const { column: endCol, row: endRow } = parseCellAddress(end);
    const cells: string[] = [];

    for (let i = startRow; i <= endRow; i++) {
      for (let j = columnToNumber(startCol); j <= columnToNumber(endCol); j++) {
        cells.push(`${numberToColumn(j)}${i}`);
      }
    }
    return cells;
  }
  return [range];
};

/**
 * 드래그 범위를 백엔드가 인식하는 cell address 배열로 변환한다.
 *
 * 머지 셀은 백엔드에 단일 셀(예: "A1:B2")로 저장된다. 범위를 그대로 펼치면
 * 앵커가 아닌 좌표(B1, B2 등)가 백엔드에 존재하지 않아 거절되므로, 머지 구역은
 * 머지 범위 문자열 하나로 대표시키고 중복을 제거한다.
 *
 * @param range        선택 범위 ("A1:C3" 또는 단일 "A1")
 * @param mergedRanges 백엔드 cell address 중 머지 셀("A1:B2" 형태) 목록
 */
export const getMergeAwareCellsFromRange = (
  range: string,
  mergedRanges: string[],
): string[] => {
  const [start, end] = range.includes(":") ? range.split(":") : [range, range];
  const lookupTable = buildCellLookupTable(start, end, mergedRanges);
  const cells = getCellsFromRange(range);
  return [
    ...new Set(cells.map((address) => lookupTable.get(address) ?? address)),
  ];
};
